import { useActionReducer } from "./reducer";
import { useActionState } from "./action-state";
import React from "react";
import { Lightbox, LightboxAspectRatio, LightboxClose, LightboxFrame } from "../../components/Lightbox";
import { Image } from "../../components/Image";
import { Icon } from "../../components/Icon";
import { Media } from "../../components/Media";
export const ActionContextLightbox = () => {
    const { showLightbox, lightboxType, url, asset, media } = useActionState();
    const { dispatchAction } = useActionReducer();
    return (React.createElement(Lightbox, { visible: showLightbox, onChange: (visible) => visible || dispatchAction({ type: "close_lightbox" }) },
        lightboxType === "youtube_video_embed" && url ? (React.createElement(LightboxAspectRatio, { width: 16, height: 9 },
            React.createElement(LightboxFrame, null,
                React.createElement("iframe", { "data-testid": "lightbox-content", tabIndex: 0, src: url, allowFullScreen: true })))) : lightboxType === "image" && asset ? (React.createElement(Image, { optimized: true, image: asset.desktop })) : lightboxType === "media" && media ? (React.createElement(Media, { media: media })) : null,
        React.createElement(LightboxClose, null,
            React.createElement(Icon, { name: "close" }))));
};
//# sourceMappingURL=ActionContextLightbox.js.map